
import Parse from 'parse';
import moment from 'moment';
import uuidv4 from 'uuid/v4';

export default {

  buildAssignment: () => {
    const obj = new Parse.Object('Assignment')
    obj.setACL(new Parse.ACL(Parse.User.current()));
    obj.set('uid', uuidv4())
    obj.set('dueAt', new Date());
    obj.set('normalizedDueAt', moment(obj.get('dueAt')).startOf('day').toDate());
    obj.set('completed', 0);
    obj.set('archived', 0);
    obj.set('plannedAt', new Date());
    obj.set('effort', 3);
    obj.set('tasks', []);

    return obj;
  },

  buildAlarm: (referenceDate, offset) => {
    const obj = new Parse.Object('Alarm');
    obj.setACL(new Parse.ACL(Parse.User.current()));
    obj.set('uid', uuidv4());
    obj.set('archived', 0);
    obj.set('referenceDayOffset', offset);
    
    var fireMoment = moment(referenceDate);
    fireMoment.subtract(offset, 'days')
              .hours(12)
              .minutes(0)
              .seconds(0)
              .milliseconds(0);
    obj.set('fireDate', fireMoment.toDate());

    return obj;
  },

  buildGrade: () => {
    const obj = new Parse.Object('Grade');
    obj.setACL(new Parse.ACL(Parse.User.current()));
    obj.set('uid', uuidv4());
    obj.set('archived', 0);
    obj.set('earnedPoints', 0);
    obj.set('totalPoints', 0);

    return obj;
  },

  buildSemester: () => {
    const obj = new Parse.Object('Semester');
    obj.setACL(new Parse.ACL(Parse.User.current()));
    obj.set('uid', uuidv4());
    obj.set('archived', 0);

    const startDate = new Date();
    obj.set('startDate', startDate);
    obj.set('endDate', moment(startDate).add(3, 'M').toDate());

    return obj;
  },

  buildTag: () => {
    const obj = new Parse.Object('Tag');
    obj.setACL(new Parse.ACL(Parse.User.current()));
    obj.set('uid', uuidv4())
    obj.set('archived', 0);
    
    return obj;
  },

  buildTask: () => {
    const obj = new Parse.Object('Task');
    obj.setACL(new Parse.ACL(Parse.User.current()));
    obj.set('uid', uuidv4());
    obj.set('archived', 0);
    obj.set('completed', 0);

    return obj
  },

}


// WEBPACK FOOTER //
// ./src/services/object-store.js